import { NodeGraphLink } from "@components/NodeLink/types"

//  @TODO (Bartek Laskowski) 2026-04-09: Make linkParse support partial links like linkEncode does - should return Partial<NodeGraphLink> for incomplete links during typing
export const linkParse = (key: string | undefined): NodeGraphLink | undefined => {
  if (!key) {
    return undefined
  }

  const [org, div, prod, familyVersionNode] = key.split("#")

  if (!org || !div || !prod || !familyVersionNode) {
    return undefined
  }

  const [family, versionNode] = familyVersionNode.split(/_(.+)/)

  if (!family || !versionNode) {
    return undefined
  }

  const [version, node] = versionNode.split("__")
  if (!version || !node) {
    return undefined
  }

  const link = { org, div, prod, family, version, node }

  return link
}

/**
 * Encodes the longest contiguous prefix using this order: org, div, prod, family, version, node.
 * Stops at the last provided argument and returns the accumulated key.
 */
export function linkEncode(org?: string): string
export function linkEncode(org: string, div: string): string
export function linkEncode(org: string, div: string, prod: string): string
export function linkEncode(org: string, div: string, prod: string, family: string): string
export function linkEncode(
  org: string,
  div: string,
  prod: string,
  family: string,
  version: string,
): string
export function linkEncode(
  org: string,
  div: string,
  prod: string,
  family: string,
  version: string,
  node: string,
): string
export function linkEncode(
  org?: string | undefined,
  div?: string,
  prod?: string,
  family?: string,
  version?: string,
  node?: string,
): string {
  let key = ""
  if (!org) return key

  key = org
  if (!div) return key

  key = `${key}#${div}`
  if (!prod) return key

  key = `${key}#${prod}`
  if (!family) return key

  key = `${key}#${family}`
  if (!version) return key

  key = `${key}_${version}`
  if (!node) return key

  return `${key}__${node}`
}
